export default __webpack_public_path__ + "images/c18cc83ca970b5c7ac409d276274f393-hannukuh.webp";